var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBenefitBetreuung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.02 34.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #defc70;\n      }\n\n      .st1 {\n        fill: #fff;\n        font-family: DINPro-Regular, DINPro;\n        font-size: 14.07px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.01,10.81c-1.41,0-2.56,1.15-2.56,2.56s1.15,2.56,2.56,2.56,2.56-1.15,2.56-2.56-1.15-2.56-2.56-2.56ZM17.01,14.62c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25.56,1.25,1.25-.56,1.25-1.25,1.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.08 23.33 22.08 19.5 21.89 19.04 19.77 16.93 19.31 16.74 14.7 16.74 14.24 16.93 12.13 19.04 11.94 19.5 11.94 23.33 13.24 23.33 13.24 19.77 14.97 18.04 19.04 18.04 20.77 19.77 20.77 23.33 22.08 23.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.17,19.3c-1.03,5.06-5.4,8.79-10.52,9.09v-3.53h-1.3v8.13h1.3v-3.3c5.73-.29,10.63-4.46,11.79-10.13l.13-.64-1.32-.03-.08.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.69,16.36c-.29-5.73-4.46-10.63-10.13-11.79l-.64-.13-.04,1.32.42.09c5.06,1.03,8.79,5.4,9.09,10.52h-2.69v1.3h7.3v-1.3h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.76,15.1l.08-.38c1.03-5.06,5.4-8.79,10.52-9.09v3.53h1.3V1.02h-1.3v3.3c-5.73.29-10.63,4.46-11.79,10.13l-.13.64,1.32.06v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.63,17.66h2.69v-1.3H1.02v1.3h3.3c.29,5.73,4.46,10.63,10.13,11.79l.64.13.05-1.32-.43-.09c-5.06-1.03-8.79-5.4-9.09-10.52Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(29.6 23.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBenefitBetreuung);
export default __webpack_public_path__ + "static/media/Icons_Benefit_Betreuung.e88877b3764c38dfc327f45766a0931c.svg";
export { ForwardRef as ReactComponent };